import { c as _c } from "react/compiler-runtime";
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { H3 } from '@/frontend/design-system/typography/Heading';
type FocusCardProps = {
  title: string;
  children: React.ReactNode;
};
export function FocusCard(t0) {
  const $ = _c(8);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ExclamationCircleIcon className="h-6 w-6" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <H3 className="flex items-center gap-2 text-contentYellow">{t1}{title}</H3>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <div className="font-normal text-base text-contentYellow leading-6">{children}</div>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <LightCard className="w-full space-y-4 border-borderWarning bg-backgroundYellow">{t2}{t3}</LightCard>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}